export default {
  Payslips: {
    batch_name: "Batch Name",
    batch_name_tooltip:
      "Assign a unique name to your payslip upload batch. You cannot use the same batch name more than once.",
    issue_date: "Issue Date",
    issue_date_tooltip:
      "Specify the date when payslips were issued by your organisation’s payroll. This is the date that will display to employees on the chatbot.",
    distribution_date: "Distribution Date",
    distribution_date_tooltip:
      "Specify the date you wish to share payslips with your employees.",
    distribution_time: "Distribution Time",
    distribution_time_tooltip:
      "Specify the time you wish to share payslips with your employees.",
    matching_criteria: "Matching Criteria",
    matching_criteria_tooltip:
      "Please select the unique identifiers that are displayed on your payslips. These identifiers will be used to match your payslips with registered employees on Jem. Ideally, you should select two identifiers for the best match. Ensure you select identifiers that appear on your payslips.",
    matching_criteria_description:
      "Choose employee identifiers for accurate payslip matching. Unique identifiers like ID or Passport numbers improve matching accuracy and processing efficiency.",
    page_breakDown: "Page Breakdown",
    page_breakDown_description:
      "Choose employee identifiers for accurate payslip matching. Unique identifiers like ID or Passport numbers improve matching accuracy and processing efficiency.",
    select_mathing_employee: "Select an employee to match",
    select_mathing_employee_tooltip:
      "Review the payslip on the left and select the employee it should be matched to from this list.",
    errors_heading: "Unassigned Payslips",
    errors_heading_tooltip:
      "Ensure you select identifiers that appear on your payslips.",
    period_dates_label: "",
    period_dates_tooltip: "",
  },
  IRP5s: {
    batch_name: "Batch Name",
    batch_name_tooltip:
      "Assign a unique name to your IRP5 upload batch. You cannot use the same batch name more than once.",
    issue_date: "Issue Date",
    issue_date_tooltip:
      "Specify the date when IRP5s were issued by your organisation’s payroll. This is the date that will display to employees on the chatbot.",
    distribution_date: "Distribution Date",
    distribution_date_tooltip:
      "Specify the date you wish to share IRP5s with your employees.",
    distribution_time: "Distribution Time",
    distribution_time_tooltip:
      "Specify the time you wish to share IRP5s with your employees.",
    matching_criteria: "Matching Criteria",
    matching_criteria_tooltip:
      "Please select the unique identifiers that are displayed on your IRP5s. These identifiers will be used to match your IRP5s with registered employees on Jem. Ideally, you should select two identifiers for the best match. Ensure you select identifiers that appear on your IRP5s.",
    matching_criteria_description:
      "Choose employee identifiers for accurate IRP5 matching. Unique identifiers like ID or Passport numbers improve matching accuracy and processing efficiency.",
    page_breakDown: "Page Breakdown",
    page_breakDown_description:
      "Choose employee identifiers for accurate IRP5 matching. Unique identifiers like ID or Passport numbers improve matching accuracy and processing efficiency.",
    select_mathing_employee: "Select an employee to match",
    select_mathing_employee_tooltip:
      "Review the IRP5 on the left and select the employee it should be matched to from this list.",
    errors_heading: "Unassigned IRP5s",
    errors_heading_tooltip:
      "Ensure you select identifiers that appear on your IRP5s.",
    period_dates_label: "",
    period_dates_tooltip: "",
  },
  Rosters: {
    batch_name: "Batch Name",
    batch_name_tooltip:
      "Assign a unique name to your roster batch. You cannot use the same batch name more than once.",
    issue_date: "Issue Date",
    issue_date_tooltip:
      "Specify the date when Rosters were issued by your organisation’s payroll. This is the date that will display to employees on the chatbot.",
    distribution_date: "Distribution Date",
    distribution_date_tooltip:
      "Specify the date you wish to share Rosters with your employees.",
    distribution_time: "Distribution Time",
    distribution_time_tooltip:
      "Specify the time you wish to share Rosters with your employees.",
    matching_criteria: "Matching Criteria",
    matching_criteria_tooltip:
      "Please select the unique identifiers that are displayed on your Rosters. These identifiers will be used to match your Rosters with registered employees on Jem. Ideally, you should select two identifiers for the best match. Ensure you select identifiers that appear on your Rosters.",
    matching_criteria_description:
      "Choose employee identifiers for accurate Roster matching. Unique identifiers like ID or Passport numbers improve matching accuracy and processing efficiency.",
    page_breakDown: "Page Breakdown",
    page_breakDown_description:
      "Choose employee identifiers for accurate Roster matching. Unique identifiers like ID or Passport numbers improve matching accuracy and processing efficiency.",
    select_mathing_employee: "Select an employee to match",
    select_mathing_employee_tooltip:
      "Review the Rosters on the left and select the employee it should be matched to from this list.",
    errors_heading: "Unassigned",
    errors_heading_tooltip:
      "Ensure you select identifiers that appear on your Rosters.",
    period_dates_label: "Roster Period",
    period_dates_tooltip: "Specify the start and end date of your roster",
  },
  Timesheets: {
    batch_name: "Batch Name",
    batch_name_tooltip:
      "Assign a unique name to your timesheet batch. You cannot use the same batch name more than once.",
    issue_date: "Issue Date",
    issue_date_tooltip:
      "Specify the date when Timesheets were issued by your organisation’s payroll. This is the date that will display to employees on the chatbot.",
    distribution_date: "Distribution Date",
    distribution_date_tooltip:
      "Specify the date you wish to share Timesheets with your employees.",
    distribution_time: "Distribution Time",
    distribution_time_tooltip:
      "Specify the time you wish to share Timesheets with your employees.",
    matching_criteria: "Matching Criteria",
    matching_criteria_tooltip:
      "Please select the unique identifiers that are displayed on your Timesheets. These identifiers will be used to match your Timesheets with registered employees on Jem. Ideally, you should select two identifiers for the best match. Ensure you select identifiers that appear on your Timesheets.",
    matching_criteria_description:
      "Choose employee identifiers for accurate Timesheet matching. Unique identifiers like ID or Passport numbers improve matching accuracy and processing efficiency.",
    page_breakDown: "Page Breakdown",
    page_breakDown_description:
      "Choose employee identifiers for accurate Timesheet matching. Unique identifiers like ID or Passport numbers improve matching accuracy and processing efficiency.",
    select_mathing_employee: "Select an employee to match",
    select_mathing_employee_tooltip:
      "Review the Timesheets on the left and select the employee it should be matched to from this list.",
    errors_heading: "Unassigned",
    errors_heading_tooltip:
      "Ensure you select identifiers that appear on your Timesheets.",
    period_dates_label: "Timesheet Period",
    period_dates_tooltip: "Specify the start and end date of your timesheet",
  },
  Announcements: {
    General: {
      selectTitle: "Generic Announcement",
      titleField: "Title",
      bodyField: "Message",
    },
    Vacancy: {
      selectTitle: "Job Vacancy",
      titleField: "Job Title",
      bodyField: "Job Description",
    },
    Benefit: {
      selectTitle: "Benefit",
      titleField: "Benefit Name",
      bodyField: "Benefit Update/Description",
    },
    "Safety Issue": {
      selectTitle: "Safety Issue",
      titleField: "Safety Issue Name",
      bodyField: "Safety Issue Update/Description",
    },
    "Policy Update": {
      selectTitle: "Policy Update",
      titleField: "Policy Name",
      bodyField: "Policy Update/Description",
    },
    "Disciplinary Notice": {
      selectTitle: "Disciplinary Notice",
      titleField: "Discipline Title",
      bodyField: "Discipline Description",
    },
    "Training & Development": {
      selectTitle: "Training & Development",
      titleField: "Training & Development Name",
      bodyField: "Training & Development Description",
    },
    "Urgent Management": {
      selectTitle: "Urgent Management",
      titleField: "Urgent Message Title",
      bodyField: "Description",
    },
    Contact: {
      selectTitle: "Contact",
      titleField: "Title",
      bodyField: "Description",
    },
    "Language Specific": {
      selectTitle: "Language Specific",
      titleField: "Message Title",
      bodyField: "Message Description",
    },
  },
};
